import React, { useContext } from 'react';
import { Stack } from '@fluentui/react';
import { useHistory } from 'react-router-dom';
import {
	NEW_ACTION_ICONS,
	EXISTING_ACTION_ICONS,
	ATTACHMENT_ACTION_ICONS,
	ACTION_TYPE,
	ACTION_ROLE,
} from '../../shared/Constants';
import BorderImage from '../../components/BorderImage';
import { iconContainerStyle, stackTokens } from '../../utility/tasks/styles';
import { ActionContext } from '../../context/ActionContext';
import { CmicContext } from '../../context/CmicContext';
import { THEME_ID, baseFontFamilyStyle } from '../../shared/styles';
import { COLORS } from '../../utility/tasks/colors';
import * as APP_CONSTANTS from '../../shared/Constants';
import {
	segmentDefaultPageCall,
	segmentDefaultTrackCall,
} from '../../utility/segment/segmentUtility';
import { isInternetAvailable } from '../../shared/UtilityFunctions';

const Actions = () => {
	const navigate = useHistory();

	const { actionTypeData, setActionTypeData, resetActionData } = useContext(ActionContext);
	const { userInfo, currentOfficeTheme, selectedProject, setShowToast } = useContext(CmicContext);

	const handleBGClr = () => {
		const theme = currentOfficeTheme?.themeId ? currentOfficeTheme?.themeId : THEME_ID.WHITE;

		switch (theme) {
			case THEME_ID.WHITE:
			case THEME_ID.COLORFUL:
				return COLORS.BG_GREY_LIGHT;
			case THEME_ID.DARK_GREY:
				return '#605E5C';
			case THEME_ID.BLACK:
				return '#262626';
			default:
				return COLORS.BG_GREY_LIGHT;
		}
	};

	// Style
	const textStyle = {
		color:
			currentOfficeTheme.themeId === THEME_ID.DARK_GREY ? '#a2a8af' : currentOfficeTheme.controlForegroundColor,
		fontWeight: 'normal',
		fontFamily: baseFontFamilyStyle,
		margin: '0 0 0.5rem 0.5rem',
	};

	const parentStyles = {
		padding: '0.5rem 0.35rem',
		margin: '0.2rem 0.3rem 0 0.1rem',
		height: '100%',
		backgroundColor: handleBGClr(),
	};

	React.useEffect(() => {
		if (userInfo.actionRole === ACTION_ROLE.ECM) {
			navigate.replace('/home/actions/list');
		}
	}, []);

	const handleBtnPress = (nodeType, label, type) => {
		if (!isInternetAvailable(setShowToast)) {
			return;
		}

		if (actionTypeData.type === type && actionTypeData.nodeType === nodeType) {
			if (userInfo.actionRole === APP_CONSTANTS.ACTION_ROLE.PROJECT && userInfo?.isCloudUser) {
				if (type === ACTION_TYPE.ATTACHMENT) {
					segmentCall();
				}
			}
			actionTypeData.type === ACTION_TYPE.ATTACHMENT
				? navigate.push(`/home/actions/documents`)
				: navigate.push(`/home/actions/list`);
			return;
		}

		if (APP_CONSTANTS.ACTION_TYPE.NEW === type) {
			if (userInfo.actionRole === APP_CONSTANTS.ACTION_ROLE.PROJECT && userInfo?.isCloudUser) {
				const obj = {
					appName: APP_CONSTANTS.APP_NAME,
					contactCode: userInfo?.info?.contactCode,
					timestamp: new Date(),
					projectName: selectedProject?.PmpProjName,
					projectId: selectedProject?.PmpVUuid,
				};

				if (nodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI) {
					segmentDefaultPageCall('CREATE_RFI', obj);
					//console.log("CREATE_RFI", obj)
				} else if (nodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE) {
					segmentDefaultPageCall('CREATE_ISSUE', obj);
					//console.log("CREATE_ISSUE", obj)
				}
			}
		}

		resetActionData();
		setActionTypeData({
			nodeType,
			label,
			type,
		});
		type === ACTION_TYPE.ATTACHMENT
			? navigate.push(`/home/actions/documents`)
			: navigate.push(`/home/actions/list`);
	};

	const segmentCall = () => {
		const EVENT_NAME = 'PM_DOCUMENT';
		const obj = {
			contactCode: userInfo?.info?.contactCode,
			timestamp: new Date(),
			projectName: selectedProject?.PmpProjName,
			projectId: selectedProject?.PmpVUuid,
			status: 'success',
		};
		segmentDefaultTrackCall(EVENT_NAME, obj);
	};

	let mainUI = null;

	if (userInfo.actionRole === ACTION_ROLE.PROJECT) {
		mainUI = (
			<>
				<Stack>
					<Stack.Item style={textStyle}>Save Attachments</Stack.Item>
					<Stack horizontal style={iconContainerStyle}>
						<BorderImage
							label="Documents"
							iconName="folder"
							isDefaultIcon={false}
							onClick={() =>
								handleBtnPress(
									ATTACHMENT_ACTION_ICONS.proj.type,
									ATTACHMENT_ACTION_ICONS.proj.label,
									ACTION_TYPE.ATTACHMENT,
								)
							}
						/>
					</Stack>
				</Stack>
				<Stack style={{ margin: '1rem 0' }}>
					<Stack.Item style={textStyle}>Create New</Stack.Item>
					<Stack horizontal style={iconContainerStyle}>
						{NEW_ACTION_ICONS.map(item => (
							<BorderImage
								key={item.label}
								label={item.label}
								iconName={item.iconName}
								isDefaultIcon={item.isDefaultIcon}
								parentStyles={item.isDisabled ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
								onClick={() =>
									item.isDisabled ? {} : handleBtnPress(item.type, item.label, ACTION_TYPE.NEW)
								}
							/>
						))}
					</Stack>
				</Stack>

				<Stack>
					<Stack.Item style={textStyle}>Add To Existing</Stack.Item>

					<Stack horizontal style={iconContainerStyle}>
						{EXISTING_ACTION_ICONS.map((dataArray, index) => (
							<Stack
								key={index}
								horizontal
								style={{ marginBottom: '1rem', ...iconContainerStyle, minWidth: '220px' }}
							>
								{dataArray.map(item => (
									<BorderImage
										key={item.label}
										label={item.label}
										isDefaultIcon={item.isDefaultIcon}
										iconName={item.iconName}
										parentStyles={item.isDisabled ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
										onClick={() =>
											item.isDisabled
												? {}
												: handleBtnPress(item.type, item.label, ACTION_TYPE.EXISTING)
										}
									/>
								))}
							</Stack>
						))}
					</Stack>
				</Stack>
			</>
		);
	}

	return (
		<Stack tokens={stackTokens} style={parentStyles}>
			{mainUI}
		</Stack>
	);
};

export default Actions;
